// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "NextPrevious-module--cds--assistive-text--e49b0";
export var cdsHideFeedback = "NextPrevious-module--cds--hide-feedback--27822";
export var cdsShowFeedback = "NextPrevious-module--cds--show-feedback--5afd9";
export var cdsSkeleton = "NextPrevious-module--cds--skeleton--c94c5";
export var cdsVisuallyHidden = "NextPrevious-module--cds--visually-hidden--39740";
export var direction = "NextPrevious-module--direction--026c0";
export var grid = "NextPrevious-module--grid--ff097";
export var isHomepage = "NextPrevious-module--isHomepage--a3f89";
export var link = "NextPrevious-module--link--2902e";
export var linkContainer = "NextPrevious-module--link-container--e6902";
export var name = "NextPrevious-module--name--7350d";
export var wrapper = "NextPrevious-module--wrapper--570e4";